
$(window).on('load', function () {
    var location_popup_shown = sessionStorage.getItem('location_popup_shown');
    var timer = setInterval(function () {
        if ($('.awesomplete').length) {
            clearInterval(timer);
            console.log("Current template:", template);
            if (template === "index" || template === "product" || template === "collection" || template === "search") {
                //popup classes
                if (location_popup_shown == null) {
                    $('html').addClass('disable-scroll');
                    $('body').addClass('show-popup');
                    $('#location-popup').fadeIn().addClass('is-open');
                    $('#location-popup .popup__content .close').hide();
                } else {
                    setTimeout(() => {
                        if (Location_entered == false) {
                            $('html').addClass('disable-scroll');
                            $('body').addClass('show-popup');
                            $('#location-popup').fadeIn().addClass('is-open');
                            $('#location-popup .popup__content .close').hide();
                        } else {
                            $('#suburb-input').val(Location_entered);
                        }
                    }, 500);
                }
            }
            if (Location_entered) {
                $('#suburb-input').val(Location_entered);
            }
        }

        // nice select
        $(".nice-select").niceSelect();

    }, 250);

    $('input[name="date_selector"]').on('change', function () {
        var selectedValue = $('input[name="date_selector"]:checked').val();
        $('input[name="date_selector"]').closest("label").removeClass("active");
        $(this).closest("label").addClass("active");
        sessionStorage.setItem('selectedValue', selectedValue);
        if (isAddressSelected()) {
            let address_entered = sessionStorage.getItem('address_entered');
            check_availability(address_entered, true);
        }
    });

    setTimeout(() => {
        $('input[name="date_selector"]:checked').closest("label").addClass("active");
    }, 500)

    var savedValue = sessionStorage.getItem('selectedValue');
    var address_entered = sessionStorage.getItem('address_entered');

    if (savedValue && address_entered && address_entered != '' && Location_entered != '') {
        // Select the radio button based on the saved value
        $('input[name="date_selector"][value="' + savedValue + '"]').prop('checked', true);
        $(".time-wrap").show();
    }

    $('.close').on('click', function () {
        $('.popup-overlay, .popup-content').removeClass('active');
        $('body').removeClass('show-banner-popup');
    });

    $('div.pop-up .close, div.pop-up .overlay').on('click', function () {
        $('#location-popup').fadeOut().removeClass('is-open');
        $('html').removeClass('disable-scroll');
        $('.popup-overlay, .popup-content').removeClass('active');
        $('body').removeClass('show-popup');
        window.location.reload();
    });

    function mySortFunc(text, input) {
        return text > input;
    }

    var autofillTimeout;

    $.getJSON(jsonUrl, function (data) {
        var addresses = [];
        $.each(data, function (key, val) {
            var sub = val.suburb.toLowerCase();
            suburb = sub[0].toUpperCase() + sub.slice(1);
            addresses.push(suburb + ',  ' + val.state + '  ' + val.postcode);
        });
        var input = document.getElementById('suburb-input');
        if (input) {
            var awesomplete = new Awesomplete(input, {
                list: addresses,
                sort: mySortFunc,
                minChars: 2,
                autoFirst: true,
                maxItems: 12,
            });

            input.addEventListener("input", function () {
                if (input.value) {
                    awesomplete.open();
                }
            });

            input.addEventListener("change", function () {
                if (input.value) {
                    awesomplete.open();
                }
            });

            if (window.innerWidth < 767) {
                autofillTimeout = setTimeout(function checkAutofill() {
                    if (input.value && !awesomplete.isOpened) {
                        awesomplete.open();
                    }
                    autofillTimeout = setTimeout(checkAutofill, 500);
                }, 500);
            }

        }
    });

    $('#suburb-input').on('input', function () {
        if ($('.postcode-error-msg').is(':visible')) {
            $('.postcode-error-msg').hide();
        }
    });

    $('#suburb-input').on('awesomplete-selectcomplete', function () {
        if ($('#suburb-input').val()) {
            var address = $('#suburb-input').val();
            $('.postcode-error-msg').hide();
            clearTimeout(autofillTimeout);
            check_availability(address);
        } else {
            $('.postcode-error-msg').show();
        }
    });

    function checkRadioSelection() {
        if (!$('input[name="date_selector"]:checked').length) {
            return false;
        } else {
            return true;
        }
    }

    function check_availability(address, isDaySelected = false) {
        var postcode = address.replace(/[^\d]+/, '');
        var suburb = address.split(',').shift();
        var dowedeliver = checkIfDelivered(postcode, suburb, address);
        console.log({ dowedeliver, isDaySelected })
        if (isDaySelected || dowedeliver == "no update") {
            return;
        }
        if (dowedeliver) {
            $('p.postcode-message').show().css('background-color', '#c9ebd1');
            $('p.postcode-message').html(
                'Delivery to Postcode ' +
                postcode +
                " is available."
            );
            $('.check-postcode').hide();
        } else {
            $('p.postcode-message').show().css('background-color', 'rgb(255, 159, 151)');
            $('p.postcode-message').html(
                "Sorry, we do not deliver to your region."
            );
            $('.check-postcode').hide();
        }

    }
});

function isAddressSelected() {
    var address_entered = sessionStorage.getItem('address_entered');
    if (address_entered && address_entered != '') {
        return true;
    } else {
        var specificMessage = "Please enter your delivery suburb or postcode.";
        if ($(".suburb-error-msg").length === 0) {
            var errorMsg = $("<p>", {
                class: "suburb-error-msg",
                style: "line-height: 1.5; font-size: 14px; padding: 10px 15px; margin: 0 0 15px; width: 100%; color: black; background-color: rgb(255, 159, 151); display: block;",
                text: specificMessage
            });
            $(".time-wrap .radio-wrapper").after(errorMsg);
        }
        return false;
    }
}

// check if the postcode is available in the system
function checkIfDelivered(postCode, city, address) {
    const obj = ebzapiets_delivery;
    const selected_location = jQuery.parseJSON(obj);
    const postal_codeLower = postCode.toLowerCase();
    let delivery_grp = null, regionname = null;
    let postal_code_found = false;

    for (const i in selected_location) {
        var location = selected_location[i];
        if (!location.enable_delivery || !location.offset) continue;
        if (!location.zipcode.enable_zipcode) continue;

        const { zip_codes, validation_type, enable_suburb_restriction, restricted_suburb } = location.zipcode;
        const postcodeSet = new Set(zip_codes.split(',').map(code => code.trim().toLowerCase()));
        if (validation_type == 1 && postcodeSet.has(postal_codeLower)) {
            if (enable_suburb_restriction && restricted_suburb && validate_suburb(postal_codeLower, restricted_suburb, city)) {
                continue;
            }
            delivery_grp = i;
            regionname = location.regionname;
            postal_code_found = true;
            break;
        }
    }

    if (postal_code_found) {
        sessionStorage.setItem('address_entered', address);
    } else {
        $('.time-wrap').hide();
        return false;
    }

    let dynamic_del_grp = checkSuburbs(postCode, city);
    if (dynamic_del_grp) {
        delivery_grp = dynamic_del_grp;
    }

    if (typeof Storage != 'undefined') {
        sessionStorage.setItem('region_popup', 'shown');
        sessionStorage.setItem('zipcode', postCode);
        sessionStorage.setItem('suburb', city);

        const sydney_postcodes = new Set([
            '2073', '2076', '2077', '2097', '2118', '2119', '2163', '2101', '2145', '2151', '2161', '2166', '2231',
            '2102', '2103', '2120', '2125', '2152', '2164', '2165', '2170', '2172', '2173', '2198', '2233', '2126',
            '2146', '2147', '2154', '2168', '2177', '2104', '2106', '2107', '2148', '2171', '2176', '2766', '2767',
            '2079', '2080', '2081', '2082', '2108', '2156', '2158', '2159', '2155', '2175', '2178', '2763', '2768',
            '2167', '2179', '2174', '2564', '2557', '2762', '2565', '2759', '2761', '2555', '2556', '2559', '2566',
            '2748', '2749', '2760', '2769', '2770', '2558', '2560', '2747', '2765', '2157', '2567', '2750', '2745', '2570'
        ]);

        let foundZip = 0;
        const selectedValue = $('input[name="date_selector"]:checked').val();
        var cap_value = selectedValue ? selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1) : '';
        var d = new Date(currentTime);
        var current_hour = d.getHours();
        var current_minutes = d.getMinutes();
        var current_full_time = current_hour * 100 + (current_minutes / 60 * 100);
        var within_cutoff = true;

        // Bouquet Logic
        if (delivery_grp === "delivery_5" && isWithinCutoffTime("delivery_16")) {
            delivery_grp = "delivery_16";
        } else if (delivery_grp === "delivery_6" && isWithinCutoffTime("delivery_21")) {
            delivery_grp = "delivery_21";
        } else if (delivery_grp === "delivery_8" && isWithinCutoffTime("delivery_28")) {
            delivery_grp = "delivery_28";
        } else if (delivery_grp === "delivery_9" && isWithinCutoffTime("delivery_15")) {
            delivery_grp = "delivery_15";
        } else if (delivery_grp === "delivery_1" && isWithinCutoffTime("delivery_32")) {
            delivery_grp = "delivery_32";
        } else if (delivery_grp === "delivery_2" && isWithinCutoffTime("delivery_32")) {
            delivery_grp = "delivery_32";
        } else if (delivery_grp === "delivery_30" && isWithinCutoffTime("delivery_32")) {
            delivery_grp = "delivery_32";
        } else if (delivery_grp === "delivery_22" && isWithinCutoffTime("delivery_23")) {
            delivery_grp = "delivery_23";
        }

        within_cutoff = isWithinCutoffTime(delivery_grp);

        if (within_cutoff && selectedValue == 'today' && sydney_postcodes.has(postCode)) {
            foundZip = 1;
        }
        console.log({ delivery_grp })

        var prm_grps = ["delivery_19", "delivery_14"];
        var additional_grps = ["delivery_16", "delivery_21", "delivery_28", "delivery_15", "delivery_32", "delivery_23"];

        if (prm_grps.includes(delivery_grp) || additional_grps.includes(delivery_grp) || !within_cutoff) {
            $('.time-wrap').hide();
            sessionStorage.setItem('selectedValue', '');
            cap_value = '';
        } else {
            if (!selectedValue && $('.time-wrap').is(':visible')) {
                var specificMessage = "Please select a delivery day option.";
                if ($(".day-error-msg").length === 0) {
                    var errorMsg = $("<p>", {
                        class: "day-error-msg",
                        style: "line-height: 1.5; font-size: 14px; padding: 10px 15px; margin: 0 0 15px; width: 100%; color: black; background-color: rgb(255, 159, 151); display: block;",
                        text: specificMessage
                    });
                    $(".time-wrap .radio-wrapper").after(errorMsg);
                }
                return "no update";
            } else if (!selectedValue) {
                $('.time-wrap').show();
                return true;
            }
        }
        updateLocationData(delivery_grp, address, regionname, foundZip, cap_value, postCode);
    }

    return true;
}

function updateLocationData(delivery_grp, address, regionname, foundZip, cap_value, postCode) {
    $.post('/cart/update.js', {
        'attributes[Location_Group]': delivery_grp,
        'attributes[Location]': address,
        'attributes[Location_Regionname]': regionname,
        'attributes[pickup-id]': '',
        'attributes[foundZip]': foundZip,
        'attributes[cap_value]': cap_value,
        'attributes[Postal-Code]': postCode
    }, function () {
        sessionStorage.setItem("selectedRegion", regionname);
        sessionStorage.setItem("delivery_grp", delivery_grp);
        sessionStorage.setItem('location_popup_shown', 'true');
        window.location.reload();
        // if (!displayDay || selectedValue) window.location.reload();
    }, 'json');
}

function checkSuburbs(postCode, city) {
    let delivery_grp = null;
    const suburbMappings = {
        '2611': ['uriarra village'],
        '4211': ['carrara', 'gavin', 'gilston', 'nerang', 'pacific pines', 'highland park'],
        '4216': ['biggera waters', 'coombabah', 'holleywell', 'paradise point', 'runaway bay'],
        '4223': ['currumbin', 'currumbin waters'],
        '4500': ['bray park', 'brendale', 'strathpine', 'warner'],
        '4553': ['mooloolah', 'mooloolah valley'],
        '4560': ['bli bli', 'nambour'],
        '6168': ['cooloongup', 'rockingham', 'peron', 'hillman'],
        '6169': ['shoalwater', 'safety bay', 'waikiki', 'warnbro'],
        '6171': ['baldivis'],
        '6166': ['coogee']
    };

    const lowerPostCode = postCode.toString();
    const lowerCity = city.trim().toLowerCase();

    if (suburbMappings[lowerPostCode]) {
        const matchedSuburbs = suburbMappings[lowerPostCode];
        if (matchedSuburbs.includes(lowerCity)) {
            if (postCode == "4553") {
                delivery_grp = "delivery_14";
            } else if (postCode == "2611") {
                delivery_grp = "delivery_19";
            } else if (postCode == "4500" || postCode == "4211" || postCode == "4216" || postCode == "4223" || postCode == "4560") {
                delivery_grp = "delivery_24";
            }
        }
    }
    return delivery_grp;
}

function isWithinCutoffTime(delivery_grp) {
    const todayStr = "{{ 'now' | date: '%Y-%m-%d' }}";
    const today = new Date(todayStr);

    let offsetDays = parseInt(offsetdata(delivery_grp) || "0", 10);
    const cutoffDate = new Date(today);
    cutoffDate.setDate(today.getDate() + offsetDays - 1);

    const formattedToday = formatDate(today);
    const formattedCutoff = formatDate(cutoffDate);

    let nextDate = new Date(today);
    nextDate.setDate(nextDate.getDate() + offsetDays);

    let disabledDates = get_disabled_dates(delivery_grp);
    console.log({ disabledDates });

    if (disabledDates.length > 0) {
        while (true) {
            const [year, month, day] = [
                nextDate.getFullYear(),
                nextDate.getMonth() + 1,
                nextDate.getDate()
            ];
            const formatted = `${year}-${month}-${day}`;

            if (!disabledDates.includes(formatted)) break;
            nextDate.setDate(nextDate.getDate() + 1);
        }
    }

    let formattedNextday = formatDate(nextDate);

    console.log('format', { offsetDays, formattedCutoff, formattedToday, formattedNextday });

    return formattedToday > formattedCutoff && formattedToday == formattedNextday;
}

function get_disabled_dates(delivery_grp) {
    var storepick_data = jQuery.parseJSON(ebzapiets_delivery);
    var selected_location = getDescendantProp(
        storepick_data,
        delivery_grp
    );
    const disabled_dates = selected_location.blackout;
    return disabled_dates;
}

function formatDate(date) {
    date = typeof date === 'object' ? date : new Date(date.replace(/-/g, '/'));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
};

function formatDate2(date) {
    var formattedDate = new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    return formattedDate;
}

function offsetdata(specific_location) {

    var obj = ebzapiets_delivery;
    var storepick_data = jQuery.parseJSON(obj);
    var selected_location = getDescendantProp(
        storepick_data,
        specific_location
    );

    var offset_days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
    ];

    var d = new Date(currentTime);
    var n = d.getDay();
    var current_hour = d.getHours();
    var current_minutes = d.getMinutes();
    day_name = offset_days[n];

    var selected_offset = selected_location.offset;
    var selected_offset_day = getDescendantProp(selected_offset, day_name);

    if (selected_offset_day.before) {
        var push_day = selected_offset_day.before;
    } else {
        var push_day = 0;
    }

    if (selected_offset_day.enable_breakpoint) {
        var break_point_val = selected_offset_day.breakpoint;
        var nextday_breakpoint = selected_offset_day.nextday_breakpoint;
        var current_full_time = current_hour * 100 + (current_minutes / 60) * 100;
        // if next day breakpoint is enabled
        if (selected_offset_day.enable_nextday_breakpoint) {
            //if after regular breakpoint and before nextday breakpoint
            if (
                current_full_time >= break_point_val &&
                current_full_time <= nextday_breakpoint
            ) {
                var before_cutoff_day = selected_offset_day.before;
                var next_day_value = 1;
                var push_day = +before_cutoff_day + +next_day_value;
            }
            //if after nextday breakpoint
            if (current_full_time >= nextday_breakpoint) {
                var push_day = selected_offset_day.after;
            }
        }
        //if no nextday breakpoint is enabled
        else {
            if (current_full_time >= break_point_val) {
                var push_day = selected_offset_day.after;
            }
        }
    }
    if (push_day == 0) {
        var selected_days = selected_location.slot;
        var selected_time_day = getDescendantProp(selected_days, day_name);
        var found = false;
        if (selected_time_day) {
            for (index_off in selected_time_day) {
                var end_time = selected_time_day[index_off].end;
                var end_hrs = parseInt(end_time / 100);
                if (parseInt(current_hour) < end_hrs) {
                    found = true;
                }
            }
        } else {
            found = true;
        }
        if (!found) {
            push_day = 1;
        }
    }
    return push_day;

}

function validate_suburb(singleValueLower, restricted_suburbs, city) {
    //suburbs will be in this format=>[2000: MILLERS POINT, PARLIAMENT HOUSE][2036: EASTGARDENS, HILLSDALE]
    var suburb_list = restricted_suburbs.split(']');
    var customer_city = city.trim().toLowerCase();
    var suburb_found = 0;
    for (var suburb in suburb_list) {
        //replace any remaining instance of ][
        var restricted_suburb = suburb_list[suburb].replace('[', '').replace(']', '').split(':');
        var zipcode = restricted_suburb[0].trim();
        if (singleValueLower == zipcode) {
            var suburbs = restricted_suburb[1].split(',');
            for (var sub in suburbs) {
                var sub_name = suburbs[sub].trim().toLowerCase();
                if (customer_city == sub_name) {
                    suburb_found = 1;
                    break;
                }
            }
        }
    }

    if (suburb_found == 0) {
        return false;
    }
    if (suburb_found == 1) {
        return true;
    }
}

function getDescendantProp(obj, desc) {
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
}
